import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    gap: ${rem(30)};
    flex-wrap: wrap;
    margin: ${rem(20)} 0 ${rem(35)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 45%;
    margin-bottom: ${rem(45)};

    @media (min-width: ${breakpoints.sm}px) {
        width: unset;
    }
`;

export const SectionIcon = styled(IconTemplate)`
    display: block;

    svg {
        width: ${rem(40)};
        height: ${rem(40)};
    }

    &.coffee,
    &.wifi {
        svg {
            width: ${rem(60)};
            height: ${rem(60)};
            margin-top: ${rem(-20)};
        }
    }
`;

export const SectionLabel = styled.span`
    text-align: center;
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    margin-top: ${rem(15)};
    line-height: ${rem(18)};
`;
